import React from 'react';
import { reverse } from 'named-urls';

import { useNavigate } from 'react-router-dom';

import routes from 'core/routes';

import { EntityModules, isRegisterEntityModule } from 'core/constants';

import { Linked } from './styles';

const GridLookupRenderer: React.FunctionComponent<{
  entity: EntityModules;
  instance: {
    uuid: string;
    name: string;
  };
  hasFocus?: boolean;
}> = ({ entity, instance, hasFocus = false }): React.ReactElement => {
  const navigate = useNavigate();

  const navigateTo = (event: React.SyntheticEvent): void => {
    if (isRegisterEntityModule(entity)) {
      navigate(reverse(routes.dashboard[entity].details, { entityId: instance.uuid || '' }));
    }
    event.stopPropagation();
  };

  // The grid moves focus to a cell's tabindex="0" child, so Enter opens the linked record as a click does.
  return (
    <Linked
      role="link"
      tabIndex={hasFocus ? 0 : -1}
      onClick={navigateTo}
      onKeyDown={(event) => event.key === 'Enter' && navigateTo(event)}
    >
      {instance.name}
    </Linked>
  );
};

export default GridLookupRenderer;
